// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"56528d2b","58":"8712e2ef","71":"6dc84d92","120":"fa13df93","158":"101a66f1","251":"db8366b9","302":"bb1ef4cc","329":"8e06b554","345":"f4506a5c","374":"4ba0bf82","453":"07a6ab98","497":"5f8afd85","628":"cbb6ea64","754":"6aafff04","854":"7cade817","960":"21e3021f"}[chunkId] + ".chunk.js";
};